import { type UrlMatcher } from '@angular/router';

const oAuthRouteSegments = ['oauth', 'square'];
export const oAuthRouteMatcher: UrlMatcher = (url) => {
  return url.length && oAuthRouteSegments.includes(url[0].path)
    ? { consumed: url.slice(0, 1) }
    : null;
};
